import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }

  async copy() {
    const text = this.textValue
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
      this.flash("Copied!")
    } catch {
      // fallback for older browsers
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.left = "-9999px"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy") } catch {}
      document.body.removeChild(ta)
      this.flash("Copied!")
    }
  }

flash(msg) {
  const el = document.createElement("div")
  el.textContent = msg
  el.setAttribute("role", "status")
  el.className = [
    "fixed bottom-6 left-1/2 -translate-x-1/2",
    "z-[9999]",                // <-- ensure on top
    "rounded-full bg-black/80 text-white",
    "px-3 py-1 text-sm pointer-events-none",
    "shadow-lg"
  ].join(" ")
  document.body.appendChild(el)
  setTimeout(() => el.remove(), 1200)
}

}
